module.exports = __webpack_public_path__ + "img/shiba-loading.5349b440.png";